import React, {useEffect, useState} from 'react';
import "./FilesPopup.css"
import {
    Backdrop,
    Box,
    Button,
    Checkbox, CircularProgress,
    Paper,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip
} from "@mui/material";
import {IoIosCloseCircle} from "react-icons/io";
import {IoCopyOutline} from "react-icons/io5";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {AiOutlineCloudDownload} from "react-icons/ai";

const FilesPopup = ({onClose, role, userCaseFiles, caseNumber}) => {
    const urlParams = new URLSearchParams(window.location.search);
    const caseId = urlParams.get("id");
    const [isClicked, setIsClicked] = useState(false);
    const [showDialogue, setShowDialogue] = useState(false);
    const [sharedUrl, setSharedUrl] = useState("");
    const [isDownloading, setIsDownloading] = useState(false);
    const {t} = useTranslation();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [showSelectAllButton, setShowSelectAllButton] = useState(true);

    useEffect(() => {
        function handleEscapeKey(event) {
            if (event.key === "Escape") {
                onClose();
            }
        }

        function handleClickOutside(event) {
            if (event.target.classList.contains('upload-single-popup')) {
                onClose();
            }
        }

        document.addEventListener('keydown', handleEscapeKey);
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
            document.removeEventListener('click', handleClickOutside);
        };
    }, [onClose]);


    useEffect(() => {
        if (selectedFiles.length > 0) {
            const fileIds = selectedFiles.map(file => file.id).join(',');
            setSharedUrl(`${window.location.origin}/sharedfiles?id=${fileIds}&caseId=${caseId}`);
        } else {
            setSharedUrl("ბმულის გენერირებისთვის აირჩიეთ ფაილები");
        }
    }, [selectedFiles, caseId]);

    const handleCheckboxChange = (file) => {
        setSelectedFiles(prevSelectedFiles => {
            const isFileSelected = prevSelectedFiles.some(f => f.id === file.id);
            if (isFileSelected) {
                return prevSelectedFiles.filter(f => f.id !== file.id);
            } else {
                return [...prevSelectedFiles, file];
            }
        });
    };

    const handleDownload = async () => {
        setIsDownloading(true)
        const payload = {
            casefileIds: selectedFiles.map(file => file.id)
        };

        const endpoint = role !== "USER"
            ? `${process.env.REACT_APP_API_BASE_URL}/CaseFilesDocumentsDownloadZip`
            : `${process.env.REACT_APP_API_BASE_URL}/CaseSharedFilesDocumentsDownloadZip`;

        try {
            const response = await axios.post(endpoint, payload, {
                responseType: 'blob',
            });

            const file = new Blob([response.data], {
                type: 'application/zip'
            });

            const fileURL = URL.createObjectURL(file);

            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', "განაცხადი N" +  caseNumber);
            document.body.appendChild(fileLink);

            fileLink.click();

            fileLink.parentNode.removeChild(fileLink);
            setIsDownloading(false)
        } catch (error) {
        }
    };


    const formatDate = (dateString) => {
        if (dateString === '0001-01-01T00:00:00') {
            return 'თარიღი არ მოიძებნა';
        }

        const date = new Date(dateString);
        if (isNaN(date)) {
            return 'თარიღი არ მოიძებნა';
        }

        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };


    if (!userCaseFiles) {
        return <div>არაფერი მოიძებნა 404</div>;
    }


    const handleSelectAllChange = () => {
        setShowSelectAllButton(false)
        setSelectedFiles(userCaseFiles.filter(file => file.decline !== 1 && file.decline !== 16 && (file.internal || file.shared)));
    };

    const handleUnSelectAllChange = () => {
        setShowSelectAllButton(true)
        setSelectedFiles([]);
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setIsClicked(true);
            setShowDialogue(true);
            setTimeout(() => {
                setIsClicked(false);
                setShowDialogue(false);
            }, 3000);
        });
    };

    return (
        <div className="files-popup">
            <div>
                <Backdrop open={isDownloading} style={{zIndex: 1000}}>
                    <CircularProgress color="inherit"/>
                </Backdrop>
                {role !== "USER" && (
                    <div style={{height: 100}}>
                        <div className="url-box">
                            <p className="url-text">{sharedUrl}</p>

                            {sharedUrl !== "ბმულის გენერირებისთვის აირჩიეთ ფაილები" && (
                                <Tooltip title={"კოპირება"}>
                                    <div>
                                        <IoCopyOutline
                                            size="1.5em"
                                            style={{
                                                color: isClicked ? '#3498db' : '#000',
                                                cursor: 'pointer',
                                                transition: 'transform 0.2s', // Add a smooth transition
                                                transform: isClicked ? 'scale(1.2)' : 'scale(1)', // Slightly enlarge on click
                                            }}
                                            onClick={() => copyToClipboard(sharedUrl)}
                                        />
                                    </div>
                                </Tooltip>
                            )}

                            {showDialogue && sharedUrl !== "ბმულის გენერირებისთვის აირჩიეთ ფაილები" && (
                                <div className="dialogue-box show">
                                    დაკოპირდა!
                                </div>
                            )}
                        </div>
                    </div>
                )}

                <IoIosCloseCircle className="upload-single-close-icon-text-editor"
                                  onClick={onClose}
                />
                <h2>დოკუმენტები</h2>
                <div className="table-scroll">
                    <Box className="answers-inside-page-secondary-content">
                        <TableContainer style={{maxHeight: 500, overflow: 'auto'}} component={Paper}>
                            <Table aria-label="file list table">
                                <TableHead className={"answers-inside-file-table-header"}>
                                    <TableRow>
                                        <TableCell>

                                            {showSelectAllButton ? (
                                                    <Button
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: 'blue',
                                                            color: 'white',
                                                            width: '150px',
                                                            margin: '10px 0',
                                                            '&:hover': {
                                                                backgroundColor: 'darkblue',
                                                            }
                                                        }}
                                                        onClick={handleSelectAllChange}
                                                    >
                                                        ყველას არჩევა
                                                    </Button>
                                                )
                                                :
                                                (
                                                    <Button
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: 'red',
                                                            color: 'white',
                                                            width: '150px',
                                                            margin: '10px 0',
                                                            '&:hover': {
                                                                backgroundColor: 'darkred',
                                                            }
                                                        }}
                                                        onClick={handleUnSelectAllChange}
                                                    >
                                                        გაუქმება
                                                    </Button>
                                                )}
                                        </TableCell>
                                        <TableCell>ფაილის დასახელება</TableCell>
                                        <TableCell>აიტვირთა</TableCell>
                                        <TableCell>{t("ნახვა")}</TableCell>
                                        <TableCell>
                                            <Tooltip
                                                title="გადმოსაწერად ამოირჩიეთ დოკუმენტები"
                                                disableHoverListener={selectedFiles.length !== 0}>
                                                <div
                                                    style={{cursor: selectedFiles.length === 0 ? "not-allowed" : "pointer"}}>
                                                    <Button
                                                        color="secondary"
                                                        disabled={selectedFiles.length === 0 || isDownloading}
                                                        onClick={handleDownload}

                                                    >
                                                        გადმოწერა
                                                    </Button>
                                                </div>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody style={{
                                    overflow: "auto"
                                }}>
                                    {userCaseFiles.map(file => (
                                        <TableRow key={file.id}>
                                            <TableCell>
                                                <Checkbox
                                                    type="checkbox"
                                                    onChange={() => handleCheckboxChange(file)}
                                                    checked={selectedFiles.some(f => f.id === file.id)}
                                                />

                                            </TableCell>
                                            <TableCell>{file.name}</TableCell>
                                            <TableCell>{formatDate(file.createdAt)}</TableCell>
                                            <TableCell>
                                                <Button
                                                    href={file.path}
                                                    target="_blank"
                                                    startIcon={<AiOutlineCloudDownload/>}
                                                >
                                                    {t("ნახვა")}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default FilesPopup;
